import { render, staticRenderFns } from "./tnc-bd.vue?vue&type=template&id=73cd3997&scoped=true"
import script from "./tnc-bd.vue?vue&type=script&lang=js"
export * from "./tnc-bd.vue?vue&type=script&lang=js"
import style0 from "./tnc-bd.vue?vue&type=style&index=0&id=73cd3997&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cd3997",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73cd3997')) {
      api.createRecord('73cd3997', component.options)
    } else {
      api.reload('73cd3997', component.options)
    }
    module.hot.accept("./tnc-bd.vue?vue&type=template&id=73cd3997&scoped=true", function () {
      api.rerender('73cd3997', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/tnc/tnc-bd.vue"
export default component.exports